import { useSelector } from 'react-redux';
import styles from './scss/buyerpersona.module.scss';
import { useEffect, useState } from 'react';
import { buyerPersonNlpData } from '../../apiservice/aiPilot';
import { dashboardAction } from '../../store/slices/dashboard';
import { useDispatcher } from '../../custom_hooks/use_app_dispatch';
import { assets } from '../../styles/assets/assets';
import { buyerPersonLycaNlpData } from '../../apiservice/aiLycaPilot';
import Loaders from '../../components/loader/loader';


const BuyerPersona = () => {

  const { moduledateFilter } = useSelector((store: any) => store.dashboardReducer)
  const [loader, setLoader] = useState(false)
  const [nlpData, setNlpData] = useState<any>(null);
  const [profileInfo, setProfileInfo] = useState<any>(null);
  const { buyerNlpData } = useSelector((store: any) => store.dashboardReducer)
  const dispatch = useDispatcher()
  const [searchTerm, setSearchTerm] = useState("");
  const [activemenu, setActiveMenu] = useState(0);

  useEffect(() => {
    const fetchNlpData = async () => {
      try {
        setLoader(true);

        const res = await buyerPersonLycaNlpData();

        if (res?.status === 200 && Array.isArray(res?.data?.message)) {
          const firstData = res.data.message ?? null;
          setNlpData(firstData); // ✅ safely set first object or null

          setProfileInfo({
            Persona_Name: firstData[0]?.cluster_name,
            Persona_Description: firstData[0]?.cluser_description,
            Persona_Summary: firstData[0]?.cluster_summary,
          });

          dispatch(dashboardAction.setBuyerPersonData(res.data.message));
        }
      } catch (error) {
        console.error("Error fetching NLP data:", error);
      } finally {
        setLoader(false);
      }
    };

    fetchNlpData();
  }, []);

  const normalize = (s: any) =>
    String(s ?? "")
      .toLowerCase()
      .normalize("NFKD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[\u2010-\u2015\u2212]/g, "-")
      .replace(/\s+/g, " ")
      .trim();

  const normalizedData = Array.isArray(buyerNlpData)
    ? buyerNlpData.map((data: any) => {
      // get first non-empty clusterX_name
      return {
        ...data,
        Persona_Name: data.cluster_name || "Unnamed Persona",
        Persona_Description: data.cluser_description ?? "",
        Persona_Summary: data.cluster_summary ?? "",
      };
    })
    : [];


  const filteredData = normalizedData.filter((d: any) =>
    normalize(d.Persona_Name).includes(normalize(searchTerm))
  );

  const info = (data: any, index: number) => {
    // normalize persona info
    const personaName = data.cluster_name || "Unnamed Persona";
    const personaDesc = data.cluser_description || "-";
    const personaSummary = data.cluster_summary || "-";

    setProfileInfo({
      ...data,
      Persona_Name: personaName,
      Persona_Description: personaDesc,
      Persona_Summary: personaSummary,
    });
  };

  return (
    <>
      {loader ? (
        <Loaders />
      ) : (
        <div className={styles.buyerpersonasec}>
          <h4 className={styles.bypheaderline}>
            A data-driven persona for <br />personalized engagement and value in CVM</h4>

          <div className={styles.bypprofilesec}>
            <div className={styles.bypplefts}>
              <div className={styles.byppheader}>Personas</div>
              <div className={styles.byppinp}>
                <img src={assets.search_icon} alt="search_icon" />
                <input
                  type="text"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className={styles.namelists}>
                {Array.isArray(filteredData) &&
                  filteredData.map((data: any, index: number) => (
                    <div
                      key={index}
                      className={`${styles.byppnames} ${activemenu === index ? styles.byppnamesactive : ""
                        }`}
                      onClick={() => {
                        setActiveMenu(index);
                        info(data, index);
                      }}
                    >
                      <img src={assets.Sendprof_icon} alt="profile" />
                      <span>{data.Persona_Name || "Unnamed Persona"}</span>
                    </div>
                  ))}
              </div>
            </div>

            {/* Right Panel */}
            <div className={styles.bypprights}>
              <div className={styles.profdetsecwrapper}>
                <div className={styles.profileheader}>
                  <div className={styles.profimg}>
                    <img src={assets.Sendprof_icon} alt="profile" />
                  </div>
                  <p className={styles.profname}>
                    {profileInfo?.Persona_Name}
                  </p>
                  <span className={styles.profiledesc}>
                    {profileInfo?.Persona_Description}
                  </span>
                </div>

                <div className={styles.profoveralldetails}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: profileInfo?.Persona_Summary || "",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );

}

export default BuyerPersona
